import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { InquiryApi } from "@lbsdk/*";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class InquiryService {
  routeParams: any;
  inquiry: any;
  onInquiryChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private inquiryApi: InquiryApi) {}

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.routeParams = route.params;

    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getInquiry()]).then(() => {
        resolve();
      }, reject);
    });
  }

  getInquiry(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.routeParams.id === "new") {
        this.onInquiryChanged.next(false);
        resolve(false);
      } else {
        this.inquiryApi
          .findById(this.routeParams.id, {
            include: [
              { relation: "player" },
              { relation: "organization" },
              {
                relation: "playerPrize",
                scope: {
                  include: "prize",
                },
              },
            ],
          })
          .subscribe(
            (response: any) => {
              this.inquiry = response;
              this.onInquiryChanged.next(this.inquiry);
              resolve(response);
            },
            (error) => reject(error)
          );
      }
    });
  }

  patchInquiry(inquiry) {
    return this.inquiryApi.patchAttributes(inquiry.id, {
      message: inquiry.message,
      readByAdmin: true,
      readByUser: false
    });
  }

  deleteInquiry(inquiryId) {
    return this.inquiryApi.deleteById(inquiryId);
  }
}
